
function MeuDesconto(){
    return <div>
        
        <h1>Meu Desconto</h1>
    </div>
}

export default MeuDesconto;